<section class="w-full flex flex-col justify-center">
  <div class="control" [ngStyle]="controlStyles">
    @if (labelEnabled) {
      <blaze-element-label
        [color]="props?.style?.general?.title?.color1"
        [extendInputPadding]="elementContext?.extendInputPadding"
        [fontFamily]="props?.style?.labelBlock?.fontFamily"
        [fontSize]="props?.style?.labelBlock?.fontSize"
        [fontStyle]="props?.style?.labelBlock?.fontStyle"
        [fontWeight]="props?.style?.labelBlock?.fontWeight"
        [horizontalAlign]="props?.content?.title?.align?.horizontal"
        [icon]="props?.content?.title?.icon"
        [iconColor]="props?.content?.title?.iconColor?.color1"
        [iconPosition]="props?.content?.title?.iconPosition"
        [iconSize]="props?.style?.labelBlock?.iconSize"
        [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
        [lineHeight]="props?.style?.labelBlock?.lineHeight"
        [position]="props?.content?.title?.position"
        [tooltip]="props?.content?.title?.tooltip"
        [width]="props?.content?.title?.width"
      >
        {{ labelText }}
      </blaze-element-label>
    }
    <div
      (click)="onAreaClicked($event)"
      [class.multiline]="isParagraph"
      [class.validation-error]="hasValidationError"
      [id]="wrapperSectionKey"
      [ngStyle]="inputWrapperStyles"
      class="input"
    >
      @if (prefix) {
        <span class="prefix">{{ prefix }}</span>
      }

      @switch (elementFormat) {
        @case ('paragraph') {
          @if (isParagraph === true) {
            <div
              [attr.data-grow-value]="formControl.value"
              [ngClass]="textareaContainerClasses$ | async"
              [ngStyle]="inputStyles"
              class="textarea-container"
            >
              <textarea
                (blur)="isFocused = false"
                (focus)="isFocused = true"
                [formControl]="formControl"
                [placeholder]="placeholder"
                [readonly]="isReadOnly"
                [tabIndex]="0"
                ngPreserveWhitespaces
                rows="1"
              >
              </textarea>
              @if (!isReadOnly) {
                <mat-icon
                  (click)="openScanner()"
                  class="scan-icon absolute icon-24 right-4 top-4"
                  svgIcon="icon_barcode_24"
                />
              }
            </div>
          }
        }
        @default {
          <input
            #inputText
            (blur)="isFocused = false"
            (focus)="isFocused = true"
            (keydown.enter)="onEnterPressed()"
            [formControl]="formControl"
            [ngStyle]="inputStyles"
            [placeholder]="placeholder"
            [readonly]="isReadOnly"
            [step]="inputStep"
            [tabIndex]="0"
            [type]="inputConfig.type"
          />
          @if (!isReadOnly) {
            <mat-icon
              (click)="openScanner()"
              class="scan-icon icon-24 mr-8"
              svgIcon="icon_barcode_24"
            />
          }
        }
      }
      @if (suffix) {
        <span class="suffix">{{ suffix }}</span>
      }
    </div>
  </div>
  @if (showErrorLabel) {
    <div class="validation" [ngStyle]="validationStyles">
      {{ errorLabel }}
    </div>
  }
</section>
